import React from 'react';
import { connect } from 'react-redux';
import {
  LocalForm,
  Form,
  Control,
  actions
} from 'react-redux-form';
import { capitalize } from '../helpers'
import shortid from 'shortid';
import swal from 'sweetalert'
// import {
//   add_columns
// } from "../actions"
import {
  scripts_index,
  create_script,
  destroy_script,
  update_script,
} from '../actions'

import FiltersUpdate from './FiltersUpdate'
import FiltersUpdateForm from './FiltersUpdateForm'
const { toast, Datepicker, FormSelect, Tooltip } = window.M

const mapStateToProps = state => {
  return {
    form: state.forms.setFilters,
    filters: state.entry.filters,
    scripts: state.script.items,
    master_id: state.entry.master_id
  };
}

const {M} = window

const mapDispatchToProps = dispatch => {
  return {
    // addColumns: (feed_id, column_string, before) => dispatch( add_columns(feed_id, column_string, before) ),
    resetForm: () => dispatch( actions.reset('setFilters') ),
    setValue: (field, value) => dispatch( actions.change(field, value) ),
    createScript: (account_id, values) => dispatch( create_script(account_id, values) ),
    updateScript: (account_id, script_id, values) => dispatch( update_script(account_id, script_id, values) ),
    deleteScript: (account_id, script_id) => dispatch( destroy_script(account_id, script_id) ),
    getScripts: (account_id) => dispatch( scripts_index(account_id) ),

  };
}

class ConnectedFiltersForm extends React.Component {
  constructor () {
    super()
    this.state = {
      fieldSelector: null,
      operatorSelector: null,
      dateSelector: null,
      scriptsSelector: null,
      currentRule: null,
      dateLimits: {
        created_at: {
          dateMax: new Date(),
          dateMin: null,
        },
        updated_at: {
          dateMax: new Date(),
          dateMin: null,
        }
      },
      localFilters: [],
      localOperations: [],
      currentType: "string",
      currentArray: false,
      currentOperator: '',
      inputVisible: true,

      showRules: null // "form" "select"
    }
  }

  resetForm() {
    this.props.resetForm()
    setTimeout(function(self) {
      const { fieldSelector, operatorSelector } = self.state
      fieldSelector.destroy()
      operatorSelector.destroy()

      const fieldsElelment = document.getElementById('fieldsSelector')
      const newFieldsSelector = FormSelect.init(fieldsElelment);
      self.setState({fieldSelector: newFieldsSelector})

      const operatorsElement = document.getElementById('operatorsSelector')
      // operatorsElement.value = "="
      const newOperatorsSelector = FormSelect.init(operatorsElement);
      self.setState({operatorSelector: newOperatorsSelector})
    }, 100, this)
    this.setState({
      currentType: "string",
      inputVisible: true
    })
  }

  hide() {
    this.props.hide()
    this.resetFilters()
  }

  resetFilters() {
    this.setState({
      localOperations: [],
      localFilters: [...this.props.filters],
      currentRule: null,
      showRules: null
    })
    this.resetForm()
    this.formDispatch( actions.change('scripts.script', '') )
    this.formDispatch( actions.reset('scripts') )
    document.querySelector('#scriptsSelector').value = ''
    this.resetScripts()
  }

  getFiltered() {
    const filters = this.state.localFilters
    this.props.resetCollapsible()
    this.props.getFiltered(filters)
  }

  componentDidUpdate(prevProps, prevState) {
    const {columns, scripts} = this.props
    const prevcolumns = prevProps.columns
    const prevscripts = prevProps.scripts
    if ( JSON.stringify(columns) !== JSON.stringify(prevcolumns) ) {
      const fs = this.state.fieldSelector
      fs.destroy()
      const fieldsElement = document.getElementById('fieldsSelector')
      const fieldsSelector = FormSelect.init(fieldsElement);
      this.setState({fieldSelector: fieldsSelector})
    }
    if ( JSON.stringify(scripts) !== JSON.stringify(prevscripts) ) {
      this.resetScripts()
    }
  }

  resetScripts() {
    const fs = this.state.scriptsSelector
    fs.destroy()
    const scriptsElement = document.getElementById('scriptsSelector')
    const scriptsSelector = FormSelect.init(scriptsElement);
    this.setState({scriptsSelector: scriptsSelector})
  }

  componentDidMount() {
    const fieldsElelment = document.getElementById('fieldsSelector')
    const fieldsSelector = FormSelect.init(fieldsElelment);
    this.setState({fieldSelector: fieldsSelector})

    const operatorsElelment = document.getElementById('operatorsSelector')
    const operatorsSelector = FormSelect.init(operatorsElelment);
    this.setState({operatorSelector: operatorsSelector})

    this.setState({localFilters: this.props.filters})

    const scriptsElement = document.getElementById('scriptsSelector')
    const scriptsSelector = FormSelect.init(scriptsElement);
    this.setState({scriptsSelector: scriptsSelector})

    const el = document.getElementById('patternHelp')
    Tooltip.init(el, {
      html:
        `<div class="patternDiv">
          <div class="patternDivHead">Examples</div>
          <div>[ab]: Pattern contains letter "a" or letter "b"</div>
          <div>cc[ab]cc: Pattern contains "ccacc" or "ccbcc"</div>
          <div>[^ab]: Pattern does not contain letters "a" and "b"</div>
          <div>(aa|bb): Pattern contains "aa" or "bb"</div>
          <div>ab: Pattern contains "ab"</div>
          <div>\\bab\\b: Pattern contains word "ab"</div>
          <div>\\Aab: Pattern begins with "ab"</div>
          <div>ab\\z: Pattern ends with "ab"</div>
          <div>\\d+: Pattern contains one or more numerical digits</div>
        </div>`
    })

    const { account_id } = this.props
    if (account_id !== undefined && account_id !== null && account_id !== '') {
      this.props.getScripts(account_id)
    }
  }

  setCurrentType(event) {
    const field = event.target.value

    const number_fields=["price", "sale_price", "title_length", "boost"]
    const boolean_fields=["newentry", "removed", "published"]
    const date_fields=["created_at", "updated_at"]

    const { currentType, operatorSelector } = this.state
    let is_date = false
    const { setValue } = this.props
    let changed = false

    if ( number_fields.indexOf(field) > -1 ) {
      if ( currentType !== "number" ) {
        changed = true
      }
      this.setState({
        currentType: "number",
        inputVisible: true
      })

    } else if ( boolean_fields.indexOf(field) > -1 ) {
      if ( currentType !== "boolean" ) {
        changed = true
      }
      this.setState({
        currentType: "boolean",
        inputVisible: false
      })
      setValue("setFilters.operator", "true")
      this.setState({ inputVisible: false })

    } else if ( date_fields.indexOf(field) > -1 ) {
      is_date = true
      if ( currentType !== "date" ) {
        changed = true
      }
      this.setState({
        currentType: "date",
        inputVisible: true
      })
      setValue("setFilters.operator", "<= ")
      this.setState({ inputVisible: true })

    } else { // string
      if ( currentType !== "string" ) {
        changed = true
      }
      this.setState({
        currentType: "string",
        inputVisible: true
      })
    }

    if ( is_date ) {
      setTimeout( (self) => {
        const elem = document.getElementById('filterValue')
        let dateMax, dateMin
        if ( field === "updated_at") {
          dateMax = self.state.dateLimits.updated_at.dateMax
          dateMin = self.state.dateLimits.updated_at.dateMin
        } else {
          dateMax = self.state.dateLimits.created_at.dateMax
          dateMin = self.state.dateLimits.created_at.dateMin
        }
        const dp = Datepicker.init(elem, {
          container: 'body',
          maxDate: dateMax,
          minDate: dateMin,
          onClose: () => {
           if (dp.date !== null && dp.date !== undefined) {
             setValue("setFilters.value", dp.date)
             elem.value = dp.date.toLocaleDateString()
           }
          }
        })
        self.setState( {
          dateSelector: dp
         } )
      }, 100, this)
    } else {
      if ( this.state.dateSelector !== null) {
        this.state.dateSelector.destroy()
      }
      this.setState( { dateSelector: null } )
    }

    if (changed) {
      setTimeout(function(self) {
        operatorSelector.destroy()
        const operatorsElement = document.getElementById('operatorsSelector')
        const operatorsSelector = FormSelect.init(operatorsElement);
        self.setState({operatorSelector: operatorsSelector})
      }, 100, this)
    }
  }

  setArrayType(event) {
    const field = event.target.value
    const arrayTypes = ["in", "notin"]
    const inputHidden = ["~", "!~", "true", "false"]
    if ( arrayTypes.indexOf(field) < 0 ) {
      this.setState({ currentArray: false })
    } else {
      this.setState({ currentArray: true })
    }

    if ( inputHidden.indexOf(field) < 0 ) {
      this.setState({ inputVisible: true })
    } else {
      this.setState({ inputVisible: false })
    }

    this.setState( { currentOperation: field } )

  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch
  }

  handleNewRule(values) {
    const {script, global, ...other} = values
    const {localFilters, localOperations} = this.state
    if (!localFilters || localFilters.length === 0 ) {
      return toast({html: "There are no filters selected"})
    } else {

      const globalValue = (global === true)
      const { feed_id, account_id } = this.props
      const { currentRule } = this.state
      const newValues = {
        ...other,
        global: globalValue,
        feed_id: feed_id,
        filters: localFilters,
        operations: localOperations
      }

      if (this.state.currentRule !== null) {
        this.props.updateScript( account_id, currentRule, newValues )
      } else {
        this.props.createScript( account_id, newValues )
      }
    }
  }

  handlePickRule(e) {
    const { value } = e.target
    const script = this.props.scripts.find( s => s.id === value )
    if (script !== undefined) {
      const { columns } = this.props
      const columnNames = columns.map( c => c.key )
      console.log("columnNames")
      console.log(columnNames)
      this.formDispatch( actions.change('scripts.name', script.name) )
      this.formDispatch( actions.change('scripts.description', script.description || '') )
      this.formDispatch( actions.change('scripts.global', script.global ) )
      this.setState({
        localFilters: script.script.filters.filter( f => columnNames.indexOf(f.field) > -1 ),
        localOperations: script.script.operations.filter( f => columnNames.indexOf(f.field) > -1 && ( f.append === "" || f.append === undefined || f.append === null || columnNames.indexOf(f.append) > -1) ),
        currentRule: script.id,
        showRules: 'form'
      })
      setTimeout( function() {
        M.updateTextFields()
      }, 150)
    } else {
      this.formDispatch(actions.reset('scripts'))
      this.setState({
        currentRule: null,
      })
    }
  }

  handleDeleteRule() {
    swal({
      title: "Delete Rule",
      text: `Do you want to delete current rule?`,
      icon: "error",
      buttons: [true, true]
    }).then( willDelete => {
      if (willDelete) {
        const { currentRule } = this.state
        const { account_id, deleteScript } = this.props
        deleteScript(account_id, currentRule)
        this.setState({currentRule: null})
        this.formDispatch(actions.reset('scripts'))
      }
    })
  }

  handleSubmit(values) {
    const { localFilters, currentType , dateLimits } = this.state
    const { created_at, updated_at } = dateLimits
    const message = "Conflicting filters will result to an empty result set. Please review your filters."
    const allowed = {
      ">=": ["<", "<=", "!="],
      ">": ["<", "<=", "!="],
      "<=": [">", ">=", "!="],
      "<": [">", ">=", "!="],
      "!=": ["<", "<=", ">", ">="],
      "<= ": [">= "],
      ">= ": ["<= "]
    }

    // if ( currentType !== "number" ) {
    if ( currentType !== "number" ) {
      // 1. check for duplicates
      // Allow for numbers, skip adding otherwise
      const findOne = localFilters.filter( (filter) => {
        return (filter.field === values.field)
      })
      if (findOne.length > 0) {
        toast({
          html: message
        })
        return
      }
    } else {
      // 2. check if number and operators match
      const currentSet = allowed[values.operator]
      const findOne = localFilters.filter( (filter) => {
        const fieldExists = ( filter.field === values.field )
        const operationAllowed = ( typeof(currentSet) !== "undefined" && filter.operation !== values.operator) // compatible operations exist and operation has not already existed
        const currentOperationAllowed = operationAllowed && ( currentSet.indexOf(filter.operator) !== -1 )
        let value_allowed = true
        if ( currentOperationAllowed ) {
          if ( fieldExists  &&  [">", ">="].indexOf(values.operator) > -1 && values.value >= filter.value) {
            value_allowed = false
          }
          if ( fieldExists  &&  ["<", "<="].indexOf(values.operator) > -1 && values.value <= filter.value) {
            value_allowed = false
          }
        } else {
          value_allowed = false
        }

        return ( fieldExists && !value_allowed )
      })
      if (findOne.length > 0) {
        toast({
          html: message
        })
        return
      }
      this.resetForm()
    }

    const allowed_empty = ["true","false","~","!~"]
    if ( allowed_empty.indexOf(values.operator) < 0 && ( typeof(values.value) === "undefined" || values.value === null || ( !(values.value instanceof Date) && values.value.trim() === "" ) ) ) {
      toast({
        html: "You must provide a value for this filter"
      })
      return
    } else if ( allowed_empty.indexOf(values.operator) < 0 && currentType === "number" ) {
      if (!( values.value > 0 || values.value === 0 )) {
        toast({
          html: "You must provide a positive numeric value for this filter"
        })
        return
      }
    }

    const short_id = shortid.generate();
    if ( currentType === "date" ) {
      if (values.operator === ">= ") {
        this.setState({
          dateLimits: {
            created_at: (values.field === "updated_at") ? {...created_at} : {
              ...created_at,
              dateMin: values.value
            },
            updated_at: (values.field === "created_at") ? {...updated_at} : {
              ...updated_at,
              dateMin: values.value
            }
          }
        })
      }
      if (values.operator === "<= ") {
        this.setState({
          dateLimits: {
            created_at: (values.field === "updated_at") ? {...created_at} : {
              ...created_at,
              dateMax: values.value
            },
            updated_at: (values.field === "created_at") ? {...updated_at} : {
              ...updated_at,
              dateMax: values.value
            }
          }
        })
      }
    }
    this.setState({localFilters: [
      ...this.state.localFilters,
      {
        key: short_id,
        ...values
      }
    ]})
    this.resetForm()
  }

  addOperation(operation) {
    console.log("ADD OPERATION")
    console.log(operation)
    const short_id = shortid.generate();
    this.setState({localOperations: [
      ...this.state.localOperations,
      {
        key: short_id,
        ...operation
      }
    ]})
  }

  removeOperation(key) {
    this.setState(
      {
        localOperations: this.state.localOperations.filter( (operation) => {
          return operation.key !== key
        })
      }
    );
  }

  removeFilter(key) {
    this.setState(
      {
        localFilters: this.state.localFilters.filter( (filter) => {
          return filter.key !== key
        })
      }
    );
  }

  render() {
    const operators={
      equals: "=",
      is_not_equal_to: "!=",
      contains: "like",
      does_not_contain: "notlike",
      is_greater_than: ">",
      is_less_than: "<",
      is_greater_than_or_equals: ">=",
      is_less_than_or_equals: "<=",
      is_any_of_values: "in",
      is_none_of_values: "notin",
      is_empty: "~",
      is_not_empty: "!~",
      is_true: "true",
      is_false: "false",
      is_before: "<= ",
      is_after: ">= "
    }

    const valid_operators={
      "string": [
        "equals", "is_not_equal_to", "contains", "does_not_contain",
        "is_any_of_values", "is_none_of_values", "is_empty", "is_not_empty"
      ],
      "number": [
        "equals", "is_not_equal_to", "is_any_of_values",
        "is_none_of_values", "is_greater_than", "is_greater_than_or_equals",
        "is_less_than", "is_less_than_or_equals", "is_empty", "is_not_empty"
      ],
      "date": [ "is_before", "is_after" ],
      "boolean": ["is_true", "is_false"]
    }

    // const required_input_types = ["=", "!=", "like", "<", ">", "<=", ">=", "in", "notin"]

    const {localFilters, currentType, currentArray, inputVisible, currentOperation} = this.state

    const {isHidden, columns, hasUpdate, scripts} = this.props

    const displayOperators = valid_operators[currentType]

    const showPatternHint = ( ["like", "in", "notin"].indexOf(currentOperation) > -1 ) ? true : false

    const patternHintClass = showPatternHint ? 'col l2 xl2' : 'hide'

    const inputLabel = (currentArray) ? "e.g: value1,/pattern1/,value2" : ( (currentType === "date" ) ? "Select Date" : (currentOperation === "like" ? "Pattern" : "Value" ) )

    const applyButton = (localFilters.length > 0) ? "Apply Filters" : "No filters"

    const display = isHidden ? 'none' : 'inline'

    return (
      <React.Fragment>

        <div className={isHidden ? 'hide' : 'row'}>

          <div className="col s3 l3 xl3 z-depth-2 pad10">
            <div>
              <Form
                model="setFilters"
                className={isHidden ? 'hide' : ''}
                style={{display: display}}
                onSubmit = { (values) => {
                  this.handleSubmit(values)
                }}
              >
                <div className="input-field">
                  <label htmlFor="fieldsSelector" className="active">Select Column to Filter</label>
                  <Control.select id="fieldsSelector" model= "setFilters.field" onChange={(e) => {
                    this.setCurrentType(e)
                  }}>
                    {
                      columns.map( (column, index) => {
                        if (column.key === "title_length") {
                          return (
                            <React.Fragment key={`frag${index}`}>
                              <option value="created_at" key="d1">Date Added</option>
                              <option value="updated_at" key="d2">Date Updated</option>
                              <option value={column.key} key={index}>{column.name}</option>
                            </React.Fragment>
                          )
                        } else if (column.key === "status") {
                          return ''
                        } else {
                          return(
                            <option value={column.key} key={index}>{column.name}</option>
                          )
                        }
                      })
                    }
                  </Control.select>
                </div>


                <div className="input-field">
                  <label htmlFor="operatorsSelector" className="active">Operator</label>
                  <Control.select id="operatorsSelector" model= "setFilters.operator" onChange={(e)=>{
                    this.setArrayType(e)
                  }}>
                    {
                      displayOperators.map( (operator, index) => {
                        return(
                          <option value={operators[operator]} key={index}>{capitalize(operator)}</option>
                        )
                      })
                    }
                  </Control.select>
                </div>

                <div className={"input-field" + ((inputVisible) ? "" : " hide")}>
                  <label htmlFor="filterValue">{ inputLabel }</label>
                  <Control.text id="filterValue" model="setFilters.value" />
                </div>

                <div className="row">
                  <div className="col l9 xl9">
                    <button type="submit" className="btn red darken-1 waves-effect waves-light pull-right"><i className="material-icons right">navigate_next</i>Add </button>
                  </div>
                  <div className={ patternHintClass } style={{marginTop: "7px", height: "10px"}}>
                    <i id="patternHelp" className="material-icons c-red">help_outline</i>
                  </div>
                </div>

              </Form>
            </div>
          </div>

          <div className="col s5 l5 xl5">
            {
              hasUpdate && localFilters.length > 0 && (
                <div className="row filtersHead">
                  <div className="col s12 l12 xl12">
                    <span className="filterTitle">Conditions for update</span>
                  </div>
                </div>
              )
            }
            {
              localFilters.map( (filter) => {
                const {key, field, operator, value} = filter
                const fieldName = (["created_at", "updated_at"].indexOf(field) > -1 ) ? ((field === "created_at" ) ? "Date Added" : "Date Updated") : ( field==="newentry" ? "New Entry" : capitalize(field) )

                const operatorName = capitalize( Object.keys(operators).filter(function(key) {return operators[key] === operator })[0] )

                let valueName = value
                if (typeof(value) === "object" && !(value instanceof Date)) {
                  valueName = "[ " + value.join(' | ') + " ]"
                } else if (value instanceof Date) {
                  valueName = value.toLocaleDateString()
                }

                const hiddenOperators = ["true", "false", "~", "!~", true, false]

                const valueClass = ( hiddenOperators.indexOf(operator) < 0 ) ? "valueColumn" : "hide"

                return (
                  <div className="row" key={key}>
                    <div className="col s1">
                      <a href="" onClick={(e) => {
                        e.preventDefault()
                        this.removeFilter(key)
                      }}>
                        <i className="material-icons c-red" title="Remove Filter">cancel</i>
                      </a>
                    </div>
                    <div className="col s11">
                      <span className="fieldColumn mr15">{fieldName}</span>
                      <span className="operatorColumn mr15">{operatorName}</span>
                      <span className={valueClass}>{valueName}</span>
                    </div>
                  </div>
                )
              }
            )}

            <a href="" className="btn red darken-1 waves-effect waves-light mr-10" onClick={(e)=>{
              e.preventDefault()
              this.hide()
            }}>Cancel</a>

            <a href="" className="btn red darken-1 waves-effect waves-light mr-10" onClick={(e)=>{
              e.preventDefault()
              this.getFiltered()
            }}><i className="material-icons right">filter_list</i>{ applyButton }</a>

            {
              (hasUpdate && localFilters.length > 0) && (
                <FiltersUpdate feed_id={this.props.feed_id} operations={this.state.localOperations} filters={this.state.localFilters} removeOperation={this.removeOperation.bind(this)}/>
              )
            }
          </div>

          {
            (hasUpdate && localFilters.length > 0) && (
              <FiltersUpdateForm
                columns={columns} addOperation={this.addOperation.bind(this)}
                operations={this.state.localOperations}
                hide={this.hide.bind(this)}
              />
            )
          }


        </div>

        <LocalForm
          model="scripts"
          onSubmit={this.handleNewRule.bind(this)}
          getDispatch={dispatch => this.attachDispatch(dispatch)}
          style={{
            minWidth: 'auto'
          }}
        >
          <div style={{
            borderTop: "1px solid #ddd",
            paddingTop: 50,
          }} className={!hasUpdate ? 'hide' : 'row scriptFlex'}>
            <a className={this.state.showRules === null ? "btn waves-effect waves-light mr-10" : 'hide'} onClick={e=>{
              e.preventDefault()
              this.setState({showRules: 'select'})
            }}>
              <i className="material-icons right">navigate_next</i>Load Rule
            </a>
            <a className={this.state.showRules !== null ? "btn waves-effect waves-light mr-10" : 'hide'}  onClick={e=>{
              e.preventDefault()
              this.resetFilters()
            }}>
              Clear
            </a>
            <a className={this.state.showRules === null ? "btn waves-effect waves-light mr-10" : 'hide'} onClick={e=>{
              e.preventDefault()
              this.setState({
                showRules: 'form',
                currentRule: null
              })
            }}>
              <i className="material-icons right">navigate_next</i>New Rule
            </a>
          </div>

          <div className={ ( hasUpdate && this.state.showRules === 'select' ) ? 'row scriptFlex' : 'hide' }>
            <div className="s2 xl2">
              <div className="input-field scriptselector">
                <label htmlFor="scriptsSelector" className="active" style={{
                  top: -6
                }}>Select Existing Rule</label>
                <Control.select id="scriptsSelector" model="scripts.script" onChange={this.handlePickRule.bind(this)}>
                  <option value="" selected>Select Rule</option>
                  {
                    scripts.filter( s => (s.global === true || s.feed_id === this.props.master_id) ).map( s => {
                      return (
                        <option key={s.id} value={s.id}>{s.name}</option>
                      )
                    })
                  }
                </Control.select>
              </div>
            </div>
          </div>

          <div id="scriptForm" className={ ( hasUpdate && this.state.showRules === 'form' ) ? 'row scriptFlex' : 'hide' } >

            <div className="col s2 xl2 mr-10">
              <div className="input-field">
                <label htmlFor="scriptsName" className="active">Name</label>
                <Control.text id="scriptsName" model="scripts.name" required />
              </div>
            </div>
            <div className="col s5 xl5 mr-10">
              <div className="input-field">
                <label htmlFor="scriptsDescription" className="active">Description</label>
                <Control.text id="scriptsDescription" model="scripts.description"  />
              </div>
            </div>
            <div className="col s2 xl2 mr-10">
              <div className="switch">
                <label htmlFor="scriptsGlobal">
                  Use on all projects
                  <Control.checkbox id="scriptsGlobal" model="scripts.global"/>
                  <span className="lever"></span>
                </label>
              </div>
            </div>
            <div className="col s2 xl2">
              <button type="submit" className="btn waves-effect waves-light pull-right">
                <i className="material-icons right">navigate_next</i>{ this.state.currentRule === null ? 'Save' : 'Update'} Rule
              </button>
            </div>
            <div className="col s1 xl1" style={{paddingTop: 6}}>
              {
                (this.state.currentRule !== null) && (
                  <a href='' onClick={e=> {
                    e.preventDefault()
                    this.handleDeleteRule()
                  }}>
                    <i className="material-icons c-red" title="Remove Rule">cancel</i>
                  </a>
                )
              }

            </div>
          </div>
        </LocalForm>

      </React.Fragment>
    )
  }
}

const FiltersForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedFiltersForm)
export default FiltersForm



// WEBPACK FOOTER //
// ./src/js/components/FiltersForm.js